import { useQuery } from "@tanstack/react-query"
import { useContext } from "react"
import api2 from "~/api2"
import { serviceRateMode } from "~/api2/orders"
import { queryKeys } from "~/constants/queryKeys"

import { AdminContext } from "~/contexts/AdminContext"
import { useOrder } from "./useOrder"
import IOrder from "~/interfaces/IOrder"

type Props = {
  orderId?: string
  campingStyleId?: string
  discount_type?: string
  serviceRate: any
  isPaid: boolean
  includedInvoice?: boolean
  enabled?: boolean
  includePayments?: boolean
}

export const usePreviews = (props: Props) => {
  const { camp } = useContext(AdminContext)
  const order = useOrder({ orderId: props.orderId })

  const isEnabled = props.enabled !== false && !!camp && !!order.data?.order

  return useQuery({
    queryKey: [
      queryKeys.RESERVATION_PREVIEWS,
      props.orderId,
      props.campingStyleId,
      props.serviceRate,
      props.discount_type,
      props.includedInvoice,
      props.includePayments,
    ],
    queryFn: () =>
      fetchPreviews({
        order: order.data?.order,
        campId: camp.id,
        campingStyleId: props.campingStyleId,
        serviceRate: props.serviceRate,
        isPaid: props.isPaid,
        discount_type: props.discount_type,
        includedInvoice: props.includedInvoice,
        includePayments: props.includePayments,
      }),
    gcTime: 0,
    enabled: isEnabled,
    retry: 2,
  })
}

const fetchPreviews = async ({
  order,
  campId,
  campingStyleId = "",
  serviceRate = serviceRateMode.pos,
  isPaid,
  discount_type = "",
  includedInvoice = false,
  includePayments = false,
}: {
  order?: IOrder
  campId: string
  campingStyleId?: string
  serviceRate?: any
  isPaid: boolean
  discount_type?: string
  includedInvoice?: boolean
  includePayments?: boolean
}) => {
  if (!order || !campId) return

  try {
    return await api2.Orders.orderAndPreviewForNew(
      order,
      campId,
      campingStyleId,
      serviceRate,
      isPaid,
      discount_type,
      includedInvoice,
      { includeInvoice: includedInvoice, includePayments },
    )
  } catch (error) {
    console.error("Error fetching previews:", error)
    throw error
  }
}
